// import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link } from '@material-ui/core';
import React from 'react';
import { ArrowBackIcon } from '../../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';

const CustomModalHeader = ({ headerText, arrowAction, center, styles,ariaLabel }) => {
    return (
        <div className={styles.headerModal}>
            {!center && arrowAction !== undefined && (
            <Link component='a' aria-label={ariaLabel} >
                <ArrowBackIcon className={'modal-header-back-icon'} onClick={arrowAction} tabIndex={0} />
            </Link>
            )}
            <div className='modal-header-text'>
                <p style={center ? { textAlign: 'center', width: '100%' } : {}}>{headerText}</p>
                <div className='modal-header-line'></div>
            </div>
        </div>
    );
};

export default CustomModalHeader;
